/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../script-hack/script-hack.component.ngfactory';
import * as i2 from '../../../../../app/shared/components/script-hack/script-hack.component';
import * as i3 from '@angular/common';
import * as i4 from '../../../../../app/shared/components/google-adwords-conversion/google-adwords-conversion.component';
import * as i5 from '@angular/router';
import * as i6 from '../../../../../app/shared/services/google-pattern-number-formatter';
const styles_GoogleAdwordsConversionComponent:any[] = ([] as any[]);
export const RenderType_GoogleAdwordsConversionComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_GoogleAdwordsConversionComponent,data:{}});
function View_GoogleAdwordsConversionComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),3,'script-hack',
      ([] as any[]),(null as any),(null as any),(null as any),i1.View_ScriptHackComponent_0,
      i1.RenderType_ScriptHackComponent)),i0.ɵdid(1,4374528,(null as any),0,i2.ScriptHackComponent,
      [i0.ChangeDetectorRef],{appendToBody:[0,'appendToBody']},(null as any)),(_l()(),
      i0.ɵted(2,0,['\n    gtag(\'event\', \'conversion\', ',');\n'])),i0.ɵpid(0,i3.JsonPipe,
      ([] as any[]))],(_ck,_v) => {
    const currVal_0:any = true;
    _ck(_v,1,0,currVal_0);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_1:any = i0.ɵunv(_v,2,0,i0.ɵnov(_v,3).transform(_co.conversionData));
    _ck(_v,2,0,currVal_1);
  });
}
export function View_GoogleAdwordsConversionComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_GoogleAdwordsConversionComponent_1)),i0.ɵdid(1,16384,(null as any),0,i3.NgIf,
      [i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any))],(_ck,
      _v) => {
    var _co:i4.GoogleAdwordsConversionComponent = _v.component;
    const currVal_0:any = _co.conversionData;
    _ck(_v,1,0,currVal_0);
  },(null as any));
}
export function View_GoogleAdwordsConversionComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'google-adwords-conversion',
      ([] as any[]),(null as any),(null as any),(null as any),View_GoogleAdwordsConversionComponent_0,
      RenderType_GoogleAdwordsConversionComponent)),i0.ɵdid(1,114688,(null as any),
      0,i4.GoogleAdwordsConversionComponent,[i5.ActivatedRoute,i6.GooglePatternNumberFormatter],
      (null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const GoogleAdwordsConversionComponentNgFactory:i0.ComponentFactory<i4.GoogleAdwordsConversionComponent> = i0.ɵccf('google-adwords-conversion',
    i4.GoogleAdwordsConversionComponent,View_GoogleAdwordsConversionComponent_Host_0,
    {offer:'offer'},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2NvZGVidWlsZC9vdXRwdXQvc3JjNDA3ODE3ODE1NS9zcmMvc3JjL2FwcC9zaGFyZWQvY29tcG9uZW50cy9nb29nbGUtYWR3b3Jkcy1jb252ZXJzaW9uL2dvb2dsZS1hZHdvcmRzLWNvbnZlcnNpb24uY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL2NvZGVidWlsZC9vdXRwdXQvc3JjNDA3ODE3ODE1NS9zcmMvc3JjL2FwcC9zaGFyZWQvY29tcG9uZW50cy9nb29nbGUtYWR3b3Jkcy1jb252ZXJzaW9uL2dvb2dsZS1hZHdvcmRzLWNvbnZlcnNpb24uY29tcG9uZW50LnRzIiwibmc6Ly8vY29kZWJ1aWxkL291dHB1dC9zcmM0MDc4MTc4MTU1L3NyYy9zcmMvYXBwL3NoYXJlZC9jb21wb25lbnRzL2dvb2dsZS1hZHdvcmRzLWNvbnZlcnNpb24vZ29vZ2xlLWFkd29yZHMtY29udmVyc2lvbi5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2NvZGVidWlsZC9vdXRwdXQvc3JjNDA3ODE3ODE1NS9zcmMvc3JjL2FwcC9zaGFyZWQvY29tcG9uZW50cy9nb29nbGUtYWR3b3Jkcy1jb252ZXJzaW9uL2dvb2dsZS1hZHdvcmRzLWNvbnZlcnNpb24uY29tcG9uZW50LnRzLkdvb2dsZUFkd29yZHNDb252ZXJzaW9uQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPHNjcmlwdC1oYWNrIFthcHBlbmRUb0JvZHldPVwidHJ1ZVwiICpuZ0lmPVwiY29udmVyc2lvbkRhdGFcIj5cbiAgICBndGFnKCdldmVudCcsICdjb252ZXJzaW9uJywge3sgY29udmVyc2lvbkRhdGF8anNvbiB9fSk7XG48L3NjcmlwdC1oYWNrPiIsIjxnb29nbGUtYWR3b3Jkcy1jb252ZXJzaW9uPjwvZ29vZ2xlLWFkd29yZHMtY29udmVyc2lvbj4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUE7dUNBQUEsVUFBQTtNQUFBLHdFQUEwRDthQUFBO01BQUE7SUFBN0M7SUFBYixXQUFhLFNBQWI7OztJQUEwRDtJQUFBOzs7O29CQUExRDtNQUFBLGlEQUFBO01BQUE7OztJQUFtQztJQUFuQyxXQUFtQyxTQUFuQzs7OztvQkNBQTtNQUFBO2lEQUFBLFVBQUE7TUFBQTtNQUFBO0lBQUE7Ozs7OyJ9



// WEBPACK FOOTER //
// /codebuild/output/src4078178155/src/src/$$_gendir/app/shared/components/google-adwords-conversion/google-adwords-conversion.component.ngfactory.ts